module.exports = __webpack_public_path__ + "static/media/MenuEarly.115eb0b9.pdf";